"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticImplements = StaticImplements;
function StaticImplements() {
    return (constructor) => {
        constructor;
    };
}
//# sourceMappingURL=StaticImplements.js.map